import { inputTypes } from '../helpers/enums';

export const loginFormConfiguration = {
  email: {
    label: 'Email',
    type: inputTypes.email,
    placeholder: 'Enter your email',
    validation: {
      required: true,
      pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
    },
  },
  password: {
    label: 'Password',
    type: inputTypes.password,
    placeholder: 'Enter your password',
    validation: {
      required: true,
      minLength: 6
    }
  }
};
